/**
 * Replaces placeholders in the format {{key}} with corresponding values from the replacements object.
 * @param str - The string containing placeholders in the format {{key}}.
 * @param replacements - An object with keys and values to replace the placeholders in the string.
 * @returns The formatted string with placeholders replaced by corresponding values.
 */
export const tFormat = (
  str: string | undefined,
  replacements: { [key: string]: string | number | boolean },
) =>
  str?.replace(/{{(.*?)}}/g, (_, k) => {
    return replacements[k.trim()].toString();
  }) || '';
